import React, { useState, useEffect } from "react";

import { Card, CardTitle, CardBody } from "reactstrap";
import { useApi } from "../../services/api";
import Intersectiongraph from "./Intersectiongraph";

export const LineColumnChart = () => {
  const { apiFetch } = useApi();
  const [monthlySalesQuantity, setMonthlySalesQuantity] = useState(null);
  const [monthlySalesValue, setmonthlySalesValue] = useState(null);
  useEffect(() => {
    async function loadData() {

      apiFetch("api/home/monthlySalesQuantity")
        .then((response) => response.json())
        .then((data) => {
          setMonthlySalesQuantity(data);
          //console.log(data)
          if(data.message === "No transactions found for the specified account")
              setMonthlySalesQuantity(null);
             else
             setMonthlySalesQuantity(data);

        })
        .catch((error) => {
          console.error("Error loading monthly sales quantity", error);
        });

        apiFetch("/api/home/monthlySalesValue")
          .then((response) => response.json())
          .then((data) => {
            setmonthlySalesValue(data);
            if(data.message === "No transactions found for the specified account")
              setmonthlySalesValue(null);
             else
             setmonthlySalesValue(data);

          })
          .catch((error) => {
            console.error("Error loading monthly sales value", error);
          })
    }
    loadData();
  }, []);
  return (
    <>
     
          <Card className="shadow" data-testid="lineColumnChartCard">
            <CardBody>
              <CardTitle
                style={{ textAlign: "left" }}
                className="card-title-prices"
                data-testid="chartTitle"
              >
                <div className="row">
                  <div className="col-md-5" style={{ textAlign: "left" }}>
                  Monthly Sales Quantity vs Monthly Sales Value
                  </div>
                </div>
              </CardTitle>
              <Intersectiongraph
              monthlySalesQuantity={monthlySalesQuantity}
              monthlySalesValue={monthlySalesValue}
            /> 
            </CardBody>
          </Card>

    </>
  );
};
